export function formatMs(ms) {
  if (ms == null || isNaN(ms)) return "—";
  const s = Math.floor(ms / 1000);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ${m % 60}m`;
  const d = Math.floor(h / 24);
  return `${d}d ${h % 24}h`;
}

export function formatNumber(n) {
  if (n == null || isNaN(n)) return "—";
  return Number(n).toLocaleString();
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString();
  } catch {
    return iso;
  }
}

// Format a bucket-start ISO timestamp (YYYY-MM-DDTHH:MM:SS) for X-axis labels.
// bucket: 'hour' | 'day' | 'week' | 'month'
//   hour  → "HH:00" (date prefix omitted; all 24 points share the same day)
//   day/week → "MM-DD"
//   month → "Mon YY"
export function formatBucketLabel(iso, bucket) {
  if (!iso) return "";
  const [datePart, timePart] = iso.split("T");
  if (!datePart) return iso;
  if (bucket === "hour") {
    const hh = (timePart || "00:00:00").slice(0, 2);
    return `${hh}:00`;
  }
  const [, m, d] = datePart.split("-");
  if (bucket === "month") {
    const dt = new Date(`${datePart}T00:00:00`);
    return dt.toLocaleString(undefined, { month: "short", year: "2-digit" });
  }
  return `${m}-${d}`;
}
